import React from "react";

export default function Projects() {
  return (
    <section className="section">
      <h2>Projects</h2>
      <div className="grid">
        {[1,2,3].map((i) => (
          <div key={i} className="card">
            <h3>Project {i}</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus sagittis lacus vel augue laoreet rutrum.
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}


